import { apiRequest } from '@/core';
import { type CreateEventPayload } from '@/slices/events/types';
import { type Event } from '@/types';

export const createEventRequest = async (data: CreateEventPayload) =>
  apiRequest<Event>({
    endpoint: 'api/events',
    method: 'POST',
    body: data,
  });
